import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { chunk } from '@belong/common/chunk';
import { VIDEO_TESTIMONIALS } from '@belong/common/VIDEO_TESTIMONIALS';
import { TEXT_TESTIMONIALS } from '@belong/common/TEXT_TESTIMONIALS';
import { getRandomSampleFromArray } from '@belong/common/getRandomSampleFromArray';
import clsx from 'clsx';
import { Carousel } from '../Carousel/Carousel.js';
import { Image } from '../Image/Image.js';
import { Text } from '../Text/Text.js';
import { VideoPlayer } from '../VideoPlayer/VideoPlayer.js';

const randomTextTestimonials = process.env.NODE_ENV !== 'production' ? TEXT_TESTIMONIALS.slice(0, 8) : getRandomSampleFromArray({
  array: TEXT_TESTIMONIALS,
  sampleSize: 8
});
function TestimonialsCarousel({
  testimonials = VIDEO_TESTIMONIALS,
  hideRecommendedTestimonials,
  theme = 'light',
  blurredEnds,
  playIconStyle = 'default'
}) {
  const curatedTestimonials = hideRecommendedTestimonials ? testimonials : [...testimonials, ...randomTextTestimonials];
  return jsxs(Fragment, {
    children: [jsx("div", {
      className: "contents md:hidden",
      children: jsx(_TestimonialsCarousel, {
        testimonials: curatedTestimonials,
        cardsPerSlide: 1,
        theme: theme,
        blurredEnds: blurredEnds,
        playIconStyle: playIconStyle
      })
    }), jsx("div", {
      className: "hidden md:contents lg:hidden",
      children: jsx(_TestimonialsCarousel, {
        testimonials: curatedTestimonials,
        cardsPerSlide: 2,
        theme: theme,
        blurredEnds: blurredEnds,
        playIconStyle: playIconStyle
      })
    }), jsx("div", {
      className: "hidden lg:contents",
      children: jsx(_TestimonialsCarousel, {
        testimonials: curatedTestimonials,
        cardsPerSlide: 3,
        theme: theme,
        blurredEnds: blurredEnds,
        playIconStyle: playIconStyle
      })
    })]
  });
}
function _TestimonialsCarousel({
  testimonials,
  cardsPerSlide,
  theme,
  blurredEnds,
  playIconStyle = 'default'
}) {
  const testimonialSlide = chunk(testimonials, cardsPerSlide);
  const textClassName = clsx({
    'text-navy': theme === 'light',
    'text-white': theme === 'dark'
  });
  return jsx(Carousel, {
    theme: theme,
    blurredEnds: blurredEnds,
    children: testimonialSlide.map((testimonialChunk, index) => {
      return jsx("div", {
        className: "flex min-w-full justify-center",
        children: testimonialChunk.map(testimonial => {
          return jsxs("div", {
            className: "relative mr-lg flex w-[350px] flex-col last:mr-0",
            children: [jsx("div", {
              className: "mb-sm",
              children: testimonial.videoSrc ? jsx(VideoPlayer, {
                videoSrc: testimonial.videoSrc,
                posterSrc: testimonial.imgSrc,
                playIconStyle: playIconStyle
              }) : jsx(Image, {
                src: testimonial.imgSrc,
                config: {
                  q: 50,
                  w: 350
                },
                alt: "",
                className: "rounded"
              })
            }), jsx(Text, {
              className: clsx('mb-lg grow', textClassName),
              children: testimonial.body
            }), jsxs(Text, {
              as: "span",
              variant: "p1",
              fontWeight: "semibold",
              className: textClassName,
              children: [testimonial.name, ' ', jsxs(Text, {
                as: "span",
                variant: "p1",
                className: textClassName,
                children: ["| ", testimonial.description]
              })]
            })]
          }, testimonial.body);
        })
      }, index);
    })
  });
}

export { TestimonialsCarousel };
